<template>
    <b-sidebar ref="sidebar" id="payment-sidebar" title="دفع المستحقات" width="550px" bg-variant="white" backdrop @shown="onShow">
        <div class="px-4 py-2">
            <b-table :items="services" :fields="fields" borderless class="services-list" :tbody-tr-class="item => item.ignore && 'disabled'" thead-class="d-none">
                <template #cell(id)="{index}">
                    <div class="d-flex flex-column">
                        <b-button variant="primary" size="small" class="sort-btn" :disabled="index == 0" @click="onOrderChanged(index, 'up')">
                            <i class="bx bx-caret-up font-size-14"></i>
                        </b-button>
                        <b-button variant="primary" size="small" class="sort-btn" :disabled="index == services.length - 1" @click="onOrderChanged(index, 'down')">
                            <i class="bx bx-caret-down font-size-14"></i>
                        </b-button>
                    </div>
                </template>
                <template #cell(eleve)="{value}">
                    {{ value.nom_ar }}<br />
                    {{ value.prenom_ar }}
                </template>
                <template #cell(service)="{item, value}">
                    <div class="d-flex align-items-center">
                        <div class="avatar-xs mr-2">
                            <span class="avatar-title rounded-circle font-size-18 bg-secondary"><i :class="value.icone"></i></span>
                        </div>
                        <div>
                            <div class="d-flex">
                                {{ value.nom_ar }}
                                <small v-if="value.mois" class="text-muted ml-1">({{ value.mois }})</small>
                            </div>
                            <div class="d-flex align-items-center">
                                <b class="d-block dir-ltr">{{ value.reste_a_paye }} DH</b>
                                <small class="text-danger ml-1" v-if="!item.ignore && item.reste">
                                    <span>الباقي</span>
                                    <b class="dir-ltr ml-1">({{ item.reste }})</b>
                                </small>
                            </div>
                        </div>
                    </div>
                </template>
                <template #cell(num_recu)="{item}">
                    <b-input :value="numsRecu[item.eleve.id]" placeholder="رقم الإيصال" style="width: 100px" />
                </template>
            </b-table>

            <hr class="my-4" />

            <vue-form-generator ref="form" class="mt-3" tag="div" :schema="formSchema" :model="form" :options="{ validateAfterChanged: true }" />
            <q-button class="mt-3" @click="onSubmit" :loading="submitLoading">إرسال المعلومات</q-button>
        </div>
    </b-sidebar>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import ReglementsService from "@/services/reglements";

    export default {
        data: () => ({
            fields: ["id", "eleve", "service", "num_recu"],
            helpers: {},
            form: {
                mode_paiement: null,
                montant: null
            },
            selectedMode: {},
            numsRecu: {},
            submitLoading: false
        }),
        methods: {
            ...mapActions({
                updateServicesOrder: "cart/reorder",
                clearServices: "cart/clear"
            }),
            onOrderChanged(index, direction) {
                this.updateServicesOrder({ index, direction, montant: this.form.montant });
            },
            async onShow() {
                const resp = await ReglementsService.GetHelpers();
                this.helpers = resp.data;
                this.form.mode_paiement = resp.data.modes_paiement[0].id;

                this.services.forEach(({ eleve }) => {
                    let lastValue = Object.values(this.numsRecu)
                        .sort()
                        .pop();
                    lastValue = lastValue ? lastValue + 1 : this.helpers.num_recu;
                    this.numsRecu[eleve.id] = this.numsRecu[eleve.id] || lastValue;
                });
            },
            async onSubmit() {
                if (!this.$refs.form.validate()) return;

                this.submitLoading = true;
                try {
                    const resp = await ReglementsService.Update({
                        form: this.form,
                        services: this.services.map(item => {
                            item.num_recu = this.numsRecu[item.eleve.id];
                            return item;
                        })
                    });

                    if (resp.success) {
                        this.form = {
                            mode_paiement: null,
                            montant: null
                        };

                        this.clearServices();

                        this.$refs.sidebar.hide();
                        this.emitter.emit("cart-submitted");
                    }
                } finally {
                    this.submitLoading = false;
                }
            }
        },
        watch: {
            "form.mode_paiement": function(mode_paiement) {
                this.selectedMode = this.helpers.modes_paiement.find(mode => mode.id == mode_paiement) || {};
            },
            "form.montant": function() {
                this.updateServicesOrder({ montant: this.form.montant });
            }
        },
        computed: {
            ...mapGetters({
                services: "cart/services"
            }),
            formSchema() {
                return {
                    groups: [
                        {
                            fields: [
                                {
                                    type: "b-radios",
                                    label: "طريقة الدفع",
                                    model: "mode_paiement",
                                    buttons: true,
                                    buttonVariant: "outline-primary",
                                    valueField: "id",
                                    textField: "nom",
                                    values: this.helpers.modes_paiement || [],
                                    attributes: {
                                        class: "w-100 dir-ltr"
                                    }
                                }
                            ]
                        },
                        {
                            styleClasses: "row",
                            fields: [
                                {
                                    type: "pikaday",
                                    label: "التاريخ",
                                    model: "date",
                                    format: "YYYY-MM-DD",
                                    required: true,
                                    styleClasses: "col",
                                    validator: "required"
                                },
                                {
                                    type: "input",
                                    inputType: "number",
                                    label: "المبلغ",
                                    model: "montant",
                                    required: true,
                                    styleClasses: "col",
                                    validator: ["required", "number"]
                                }
                            ]
                        },
                        {
                            styleClasses: "row",
                            fields: [
                                {
                                    visible: this.selectedMode.banque,
                                    type: "vueMultiSelect",
                                    label: "البنك",
                                    placeholder: "",
                                    model: "banque",
                                    required: true,
                                    styleClasses: "col",
                                    validator: "required",
                                    selectOptions: {
                                        //key: "name",
                                        label: "nom",
                                        showLabels: false
                                    },
                                    values: this.helpers.banques || []
                                },
                                {
                                    visible: this.selectedMode.num,
                                    type: "input",
                                    inputType: "text",
                                    label: "رقم العملية",
                                    model: "num_mode_paiement",
                                    styleClasses: "col",
                                    max: 30,
                                    validator: ["string"]
                                },
                                {
                                    visible: this.selectedMode.date,
                                    type: "pikaday",
                                    label: "تاريخ الدفع",
                                    model: "date_echeance",
                                    styleClasses: "col"
                                }
                            ]
                        }
                    ]
                };
            }
        }
    };
</script>

<style lang="scss">
    .b-sidebar {
        &-header {
            font-size: 20px !important;
            direction: ltr;
            padding: 15px 25px !important;
        }
    }

    .services-list {
        border-collapse: separate;
        border-spacing: 0 10px;

        tr {
            background-color: $light;

            &.disabled {
                background-color: $white;
                opacity: 0.3;
            }
        }

        td {
            vertical-align: middle;

            &:first-child,
            &:last-child {
                width: 0;
            }
        }

        .sort-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 2px 0;
            width: 25px;

            &:not(:last-child) {
                margin-bottom: 4px;
            }
        }
    }
</style>
